import React from "react";
import { Link } from "react-router-dom";
import InfoCard from "../components/InfoCard";
// import EventCard from "../components/EventCard";
import MemberCard from "../components/MemberCard";
import SectionHeading from "../components/SectionHeading";
import SponsorsSection from "../components/SponsorsSection";
import PhotoCarousel from "../components/PhotoCarousel";
// import { heroImages, brandImages } from "../config/images";
// import { heroSlideImage } from "../config/images";
import { identityImages } from "../config/images";
import siteContent from "../config/siteContent";

/**
 * Home page
 * Props:
 *  - content: siteContent.home
 *  - brand: siteContent.brand
 */
function Home({ content, brand }) {
	// const slides = content.heroSlides || [];

  return (
    <>
      {/* HERO */}
      {/* <section className="apk-hero">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <span className="hero-badge mb-4">{brand.tagline}</span>
              <h1 className="fw-bold hero-title mt-3 mb-3">{content.heroTitle}</h1>
              <p className="lead hero-subtext mb-4">{content.heroSubtext}</p>
              <div className="d-flex gap-3 flex-wrap">
                <Link to={content.ctaPrimary.path} className="btn btn-brand btn-lg px-4">
                  {content.ctaPrimary.label}
                </Link>
                <Link to={content.ctaSecondary.path} className="btn btn-outline-brand btn-lg px-4">
                  {content.ctaSecondary.label}
                </Link>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="hero-collage">
                <img src={heroImages.templeCollage} alt="Andhra Pradesh heritage" className="hero-collage-img hero-collage-main" />
                <img src={heroImages.nzCollage} alt="New Zealand landscape" className="hero-collage-img hero-collage-secondary" />
                <div className="hero-collage-badge">
                  <img src={brandImages.logo} alt={`${brand.name} logo`} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="apk-hero-wave" aria-hidden="true"></div>
      </section> */}

	  <section className="hero-section py-5">
      <div className="container text-center">
        <h1 className="fw-bold display-6 mb-4">{siteContent.home.heroTitle}</h1>
        <span className="hero-badge mb-4">{siteContent.home.heroTagline}</span>
        {/* <p className="lead mx-auto" style={{ maxWidth: "700px" }}>{siteContent.home.heroTagline}</p> */}
      </div>
    </section>


    {/* COMMUNITY MOMENTS CAROUSEL */}
    <section className="section pt-5">
      <div className="container">
        {/* <SectionHeading eyebrow="Community Moments" title="Snapshots From Our Journey" align="center" /> */}
        <PhotoCarousel images={content.momentsCarousel} carouselId="apkMomentsCarousel" />
      </div>
    </section>

      {/* HERO CAROUSEL */}
      {/* <section className="apk-hero-carousel">
        <div id="apkHeroCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5500">
          {slides.length > 1 && (
            <div className="carousel-indicators">
              {slides.map((slide, idx) => (
                <button
                  key={slide.id}
                  type="button"
                  data-bs-target="#apkHeroCarousel"
                  data-bs-slide-to={idx}
                  className={idx === 0 ? "active" : ""}
                  aria-current={idx === 0 ? "true" : undefined}
                  aria-label={`Slide ${idx + 1}`}
                ></button>
              ))}
            </div>
          )}

          <div className="carousel-inner">
            {slides.map((slide, idx) => (
              <div className={`carousel-item${idx === 0 ? " active" : ""}`} key={slide.id}>
                <div
                  className="apk-hero-slide"
                  style={{ backgroundImage: `url(${heroSlideImage(slide.image)})` }}
                >
                  <div className="apk-hero-slide-overlay">
                    <div className="container text-center">
                      <span className="hero-badge mb-4">{slide.eyebrow}</span>
                      <h1 className="fw-bold hero-title mt-3 mb-3 mx-auto" style={{ maxWidth: "820px" }}>
                        {slide.title}
                      </h1>
                      <p className="lead hero-subtext mb-4 mx-auto" style={{ maxWidth: "620px" }}>
                        {slide.text}
                      </p>
                      <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <Link to={content.ctaPrimary.path} className="btn btn-brand btn-lg px-4">
                          {content.ctaPrimary.label}
                        </Link>
                        <Link to={content.ctaSecondary.path} className="btn btn-outline-brand btn-lg px-4">
                          {content.ctaSecondary.label}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {slides.length > 1 && (
            <>
              <button className="carousel-control-prev" type="button" data-bs-target="#apkHeroCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#apkHeroCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </>
          )}
        </div>
        <div className="apk-hero-wave" aria-hidden="true"></div>
      </section> */}

	  {/* {Members} */}

	  <section className="section">
      <div className="container">
        <SectionHeading eyebrow="Meet the team" title="Our Committee Members" />
        <div className="row g-4">
          {siteContent.members.list.map((member) => (
            <div className="col-md-6 col-lg-4" key={member.id}>
              <MemberCard member={member} />
            </div>
          ))}
        </div>
    {/* <div className="text-center mt-5">
          <Link to="/menbers" className="btn btn-outline-brand btn-lg px-4" style={{ borderColor: "var(--apk-navy)", color: "var(--apk-navy)" }}>
            View All Committee Members
          </Link>
        </div> */}
      </div>
    </section>

	  {/* EVENTS PREVIEW */}
      {/* <section className="section bg-cream">
        <div className="container">
          <SectionHeading
            eyebrow="What's on"
            title={siteContent.events.title}
            subtitle={siteContent.events.subtitle}
          />
          <div className="row g-4">
            {siteContent.events.list.slice(0, 3).map((event) => (
              <div className="col-md-6 col-lg-4" key={event.id}>
                <EventCard event={event} />
              </div>
            ))}
          </div>
          <div className="text-center mt-5">
            <Link to="/events" className="btn btn-outline-brand btn-lg px-4" style={{ borderColor: "var(--apk-navy)", color: "var(--apk-navy)" }}>
              View All Events
            </Link>
          </div>
        </div>
      </section> */}

      {/* HIGHLIGHTS */}
      <section className="section">
        <div className="container">
          <SectionHeading
            eyebrow="What we stand for"
            title="Building Community, Together"
          />
          <div className="row g-4">
            {content.highlights.map((item, idx) => (
              <div className="col-md-6 col-lg-3" key={idx}>
                <InfoCard icon={item.icon} title={item.title} text={item.text} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* STATE SYMBOLS / IDENTITY */}
      <section className="section identity-section">
        <div className="container">
          <SectionHeading
            eyebrow="Our Identity"
            title={content.stateSymbols.heading}
            subtitle={content.stateSymbols.text}
          />

          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="identity-card">
                <img src={identityImages.stateBird} alt="Rama Chiluka/Rose-ringed Parakeet, the state bird of Andhra Pradesh" />
                <div className="identity-card-overlay">
                  <span className="identity-card-icon"><i className="bi bi-feather"></i></span>
                  <div className="identity-card-label">{content.stateSymbols.items[0].label}</div>
                  <div className="identity-card-value">{content.stateSymbols.items[0].value}</div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="identity-card">
                <img src={identityImages.stateAnimal} alt="Krishna Jinka/Blackbuck, the state animal of Andhra Pradesh" />
                <div className="identity-card-overlay">
                  <span className="identity-card-icon"><i className="bi bi-flower2"></i></span>
                  <div className="identity-card-label">{content.stateSymbols.items[1].label}</div>
                  <div className="identity-card-value">{content.stateSymbols.items[1].value}</div>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-4">
              <div className="identity-card">
                <img src={identityImages.heritage} alt="Temple architecture heritage of Andhra Pradesh" />
                <div className="identity-card-overlay">
                  <span className="identity-card-icon"><i className="bi bi-bank2"></i></span>
                  <div className="identity-card-label">{content.stateSymbols.items[2].label}</div>
                  <div className="identity-card-value">{content.stateSymbols.items[2].value}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

	  {/* SPONSORS */}
      <SponsorsSection content={siteContent.sponsors} />

      {/* CTA STRIP */}
      <section className="section">
        <div className="container text-center">
          <h3 className="fw-bold text-navy mb-3">Ready to be part of our journey?</h3>
          <p className="text-secondary mb-4">
            Join hundreds of Andhra families building a home away from home in Aotearoa.
          </p>
          <Link to="/contact" className="btn btn-brand btn-lg px-4">Get Involved</Link>
        </div>
      </section>
    </>
  );
}

export default Home;
